'use client';

import { Button } from '@common/components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useShallow } from 'zustand/react/shallow';

import { AuthApi, AuthQueryKey, TERM_CATEGORY } from '@/api';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { useGlobalStore } from '@/stores/GlobalStore';

export const LocationServiceConsentDrawer = () => {
  const [
    handleLocationServiceConsentDrawer,
    setHandleLocationServiceConsentDrawer,
    setTermsDrawerType,
  ] = useGlobalStore(
    useShallow((state) => [
      state.handleLocationServiceConsentDrawer,
      state.setHandleLocationServiceConsentDrawer,
      state.setTermsDrawerType,
    ]),
  );

  const isLocationServiceConsentDrawerOpened =
    !!handleLocationServiceConsentDrawer;

  const queryClient = useQueryClient();

  const updateLocationServiceConsentMutation = useMutation({
    mutationFn: (isAgree: boolean) =>
      AuthApi['put:/wello/v2/auth/member-wello/location-service-consent']({
        body: {
          locationServiceConsentYN: isAgree,
        },
      }),
    onSuccess: async (_, isAgree) => {
      await queryClient.invalidateQueries({
        queryKey:
          AuthQueryKey[
            'get:/wello/v2/auth/member-wello/location-service-consent'
          ](),
      });

      await handleLocationServiceConsentDrawer?.(isAgree);

      setHandleLocationServiceConsentDrawer(undefined);
    },
  });

  return (
    <ResponsiveDialog
      opened={isLocationServiceConsentDrawerOpened}
      drawerType="bottom"
    >
      <h3 className="text-700 mb-8 text-Gray-900 typo-body2">
        위치기반서비스 이용약관에 동의해주세요
      </h3>
      <p className="font-400 text-Gray-700 typo-body4">
        현재 위치 정보 확인을 위해 위치기반서비스 이용약관 동의가 필요합니다.
        <button
          className="ml-8 font-600 text-Gray-black underline"
          type="button"
          onClick={() =>
            setTermsDrawerType(TERM_CATEGORY.LOCATION_POLICY_SELECT)
          }
        >
          보기
        </button>
      </p>

      <footer className="mt-28 flex gap-8">
        <Button
          className="min-w-120"
          loading={updateLocationServiceConsentMutation.isPending}
          theme="sub-line"
          onClick={() => {
            updateLocationServiceConsentMutation.mutate(false);
          }}
        >
          동의안함
        </Button>
        <Button
          className="flex-1"
          loading={updateLocationServiceConsentMutation.isPending}
          onClick={() => {
            updateLocationServiceConsentMutation?.mutate(true);
          }}
        >
          동의함
        </Button>
      </footer>
    </ResponsiveDialog>
  );
};
